<template>
  <div style="background-color: #F9F9F9;min-height: 100vh">
    <headNav>
      <div slot="headNavText">{{$t('message.yys_rz')}}</div>
    </headNav>
    <div class="container">
      <div>
        <div class="circle"></div>
        <div class="circle"></div>
        <div class="circle circle1">03</div>
        <div class="circle"></div>
      </div>
      <div class="scsf">
        <div>{{$t('message.yys_rz')}}</div>
        <div>{{$t('message.yys_tip')}}</div>
      </div>
      <div >
        <img src="../../../../assets/images/3x/yys.png" alt="">
      </div>
      <div class="tips">
        <h3>{{$t('message.rz_intro')}}</h3>
        <div>1、{{$t('message.rz_intro1')}};</div>
        <div>2、{{$t('message.rz_intro2')}};</div>
        <div>3、{{$t('message.rz_intro3')}};</div>
      </div>
      <van-button type="primary" size="normal" round class="btns" block @click="goYys">
        {{$t('message.start_rz')}}
      </van-button>
      <div style="text-align: center;padding-bottom: 0.2rem;margin-top: 0.4rem" v-if="canOver==true" @click="skip">{{$t('message.yys_tg')}}</div>
    </div>
  </div>
</template>

<script>
  import headNav from "../../../HeadNav/headNav";
  import {yys_isvarify,yys_display} from '../../../../ports/port'
  export default {
    name: "yys",
    data(){
      return{
        canOver:false
      }
    },
    created() {
      this.$router.replace({
        path: this.$route.path, // 保留当前路径
        query: {
          ...this.$route.query, // 保留已有的 query 参数
          chntoken: sessionStorage.getItem('chntoken')  // 添加新的参数
        }
      });
      yys_display({})
        .then(res => {
          if (res.data.code == 200) {
            if (res.data.data.yys_is_varify == 1) {
              this.canOver = false   //不可跳过
            } else {
              this.canOver = true;//可跳过
            }
          }
        })
        .catch(err=>{
          this.$store.commit('edit',false);//关闭全局的loading
          if(err.toString().indexOf('timeout')!=-1){
            this.$toast({message:this.$t("message.service_timeout"),type:'danger',icon:'fail'});
          }
        })
    },
    components:{
      headNav
    },
    methods:{
      goYys(){
        switch (this.$Language) {
          case "VN":
            this.$router.replace('/yys_send');
            break;
          default:
            this.$router.push('/chooseYYS');
        }
        //
      },
      skip(){
        this.$router.replace('/home');
      }
    }
  }
</script>

<style scoped lang="scss">
  .btns {
    @include defaultBtn;
    margin: 0.5rem 0 0.2rem;
  }
  .container {
    padding: 1.6rem 15px 0.5rem;
    background-color: #F9F9F9;
    .circle {
      width: 0.19rem;
      height: 0.19rem;
      background-color: #D5D5D5;
      border-radius: 0.19rem;
      display: inline-block;
      margin-right: 5px;
    }

    .circle1 {
      width: 0.53rem;
      height: 0.53rem;
      background: $color;
      border-radius: 50%;
      color: #fff;
      text-align: center;
      line-height: 0.53rem;
    }

    .scsf {
      & :nth-child(1) {
        font-size: 0.53rem;
        font-weight: 600;
        color: $color;
        margin: 0.36rem 0 0.3rem;
      }

      & :nth-child(2) {
        font-size: 0.37rem;
        font-weight: 300;
        color: #878686;
      }
      ~div{
        text-align: center;
        margin-top:1.5rem ;
        img{
          height: 5.47rem;
          width: 2.83rem;
        }
      }
    }
    .tips{
      margin-top:1rem!important;
      text-align: left!important;
      h3{
        color: #242424;
        font-size: 0.37rem;
        font-weight: 500;
      }
      div{
        font-size: 0.32rem;
        font-weight: 400;
        color: #878686;
        padding:0.15rem 0
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/loanRecord/personInfo/yys/yys.vue